App.directive('formTplDisabled', ['$window', 'Config', '$filter', 'statesService', function ($window, Config, $filter, statesService) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            assured: '<?',
            noTeleaddressFields: '=?',
            additionalFields: '=',
            // @TODO <HEALTH2019>
            isHealth: '<?',
            isZoch: '<?'
            // @TODO </HEALTH2019>
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-tpl-disabled.html',
        link: function(scope) {
    	    scope.assured = scope.assured || false;
    	    scope.noTeleaddressFields = scope.noTeleaddressFields || false;
    	    scope.isAdditionalField = function(fieldName){
    	        if(scope.additionalFields){
    	            if(scope.additionalFields.length){
    	                if(scope.additionalFields.indexOf(fieldName) !== -1){
    	                    return true;
                        }
                    }
                }
                return false;
            };
    	    console.log('scope.assured', scope.assured, scope);
        }
    };
}]);
